<mat-card>
    <div class="div_header mt-3">
        <h6 class="text_sty">File Details</h6>
        <hr>
        <div class="inner_div mt-1">
            <div class="row">
                <div class="col-md-6">
                    <p>Applicant Name&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-6 text-right">{{clerkNocService.Obj['party_name']}}</div>
            </div>
            <div class="row ">
                <div class="col-md-6">
                    <p>Applicant Mobile Number&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-6 text-right">{{clerkNocService.Obj['party_mobile']}}</div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <p>LDA Letter Number&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-6 text-right">{{clerkNocService.Obj['lda_letter_number']}}</div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <p>Building Type&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-6 text-right">{{clerkNocService.Obj['building_type']}}</div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <p>File Number&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-6 text-right">{{clerkNocService.Obj['file_number']}}</div>
            </div>
        </div>
    </div>
    <!-- ////////////////////////////////// -->
    <div class="div_header">
        <div class="inner_div mt-1">
            <div class="row mt-2">
                <div class="col-12">
                    <h6>Building Category according to Map</h6>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-4">
                    <h6>Building Type</h6>
                </div>
                <div class="col-md-4">
                    <h6>All Floors Building area</h6>
                </div>
                <div class="col-md-4">
                    <h6>Total Area</h6>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-4">
                    <p>Select Building Type &nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-4">
                    <p>In Square meter&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-4">
                    <p>In Square meter&nbsp;<span style="color: red">*</span> :</p>
                </div>
            </div>
            <div class="row ">
                <div class="col-md-3">
                    <input class="form-control" type="text" [(ngModel)]="clerkNocService.Obj['building_type']" disabled>

                </div>
                <div class="col-md-1"></div>
                <div class="col-md-3">
                    <input class="form-control" type="number" placeholder="Enter Area" (input)="validateNumber($event)"
                        [(ngModel)]="clerkNocService.Obj['floor_buld_area']" disabled>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-3">
                    <input class="form-control" type="number" placeholder="Enter Area"  (keydown)="preventSpecialCharacters($event)"
                        [(ngModel)]="clerkNocService.Obj['total_area']" disabled (keyup)="calculation()">
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-12">
                    <h6>As per the Presented building map:</h6>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <p>Front Setback&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-3">
                    <p>Side Setback L&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-3">
                    <p>Side Setback R&nbsp;<span style="color: red">*</span> :</p>
                </div>
                <div class="col-md-3">
                    <p>Rare Set Back&nbsp;<span style="color: red">*</span> :</p>
                </div>
            </div>
            <div class="row ">
                <div class="col-md-3">
                    <input class="form-control" type="number" placeholder="Enter Area"
                        [(ngModel)]="clerkNocService.Obj['front_stack']" disabled  (keydown)="preventSpecialCharacters($event)">
                </div>
                <div class="col-md-3">
                    <input class="form-control" type="number" placeholder="Enter Area"
                        [(ngModel)]="clerkNocService.Obj['side_stack_l']" disabled (keydown)="preventSpecialCharacters($event)">
                </div>
                <div class="col-md-3">
                    <input class="form-control" type="number" placeholder="Enter Area"
                        [(ngModel)]="clerkNocService.Obj['side_stack_r']" disabled  (keydown)="preventSpecialCharacters($event)">
                </div>
                <div class="col-md-3">
                    <input class="form-control" type="number" placeholder="Enter Area"
                        [(ngModel)]="clerkNocService.Obj['rare_stack']" disabled  (keydown)="preventSpecialCharacters($event)">
                </div>
            </div>
            <br>


        </div>
        <div class="outer_div">
            <div class="row">
                <div class="col-12 text-center">
                    <h6>Applicable Fees</h6>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    Reinforcement Fee per Square meter
                </div>
                <div class="col-4">
                    All Floor Area
                </div>
                <div class="col-4">
                    Amount
                </div>

            </div>
            <div class="row">
                <div class="col-md-4">
                    <input class="form-control" type="number" placeholder="₹ {{clerkNocService.Obj['reinfor_fees']}}"
                        disabled>
                </div>
                <div class="col-md-4">
                    <input class="form-control" type="number"  placeholder="{{clerkNocService.Obj['total_area'] }} m2" disabled>

                    <!-- <input class="form-control" type="number" [(ngModel)]="clerkNocService.Obj['total_area']" disabled> -->
                </div>
                <div class="col-md-4">
                    <input class="form-control" type="number"
                        placeholder="₹ {{clerkNocService.Obj['total_reinfor_fees']}}" disabled>

                </div>

            </div>
            <div class="row mt-2">
                <div class="col-md-4">
                    Dump fees per Square meter
                </div>
                <div class="col-md-4">
                    All Floor Area
                </div>
                <div class="col-md-4">
                    Amount
                </div>

            </div>
            <div class="row">
                <div class="col-md-4">
                    <input class="form-control" type="number" placeholder="₹ {{clerkNocService.Obj['dump_fees']}}"
                        disabled>
                </div>
                <div class="col-md-4">
                    <input class="form-control" type="number" placeholder="{{clerkNocService.Obj['total_area']  }} m2" disabled>

                    <!-- <input class="form-control" type="number" [(ngModel)]="clerkNocService.Obj['total_area']" disabled> -->
                </div>
                <div class="col-md-4">
                    <input class="form-control" type="number" placeholder="₹ {{clerkNocService.Obj['total_dump_fees']}}"
                        disabled>

                </div>

            </div>
            <div class="row mt-2">
                <div class="col-md-4">
                    Inspection Fee per Square meter
                </div>
                <div class="col-md-4">
                    All Floor Area
                </div>
                <div class="col-md-4">
                    Amount
                </div>

            </div>
            <div class="row">
                <div class="col-md-4">
                    <input class="form-control" type="number" placeholder="₹ {{clerkNocService.Obj['inspection_fees']}}"
                        disabled>
                </div>
                <div class="col-md-4">
                    <input class="form-control" type="number"  placeholder="{{clerkNocService.Obj['total_area']}} m2" disabled>

                    <!-- <input class="form-control" type="number" [(ngModel)]="clerkNocService.Obj['total_area']" placeholder="{{clerkNocService.Obj['total_area']}} m2" disabled> -->
                </div>
                <div class="col-md-4">
                    <input class="form-control" type="number"
                        placeholder="₹ {{clerkNocService.Obj['total_inspection_fees']}}" disabled>
                </div>

            </div>
            <div class="row mt-4" *ngIf="clerkNocService.Obj['bill_amount']">
                <div class="col-6">
                    Grand Total
                </div>
                <div class="col-6 text-right">
                    ₹ {{clerkNocService.Obj['bill_amount']}}
                </div>
            </div>
            <div class="row mt-1" *ngIf="clerkNocService.Obj['bill_word']">
                <div class="col-6">
                    In Words
                </div>
                <div class="col-6 text-right">
                    {{clerkNocService.Obj['bill_word']}} Only
                </div>
            </div>

        </div>
        <br>
    </div>
    <br><br>
</mat-card>